/**
 * 表单验证工具类
 * 提供常用的表单验证方法
 */

/**
 * 验证手机号
 * @param {*} rule 验证规则
 * @param {string} value 手机号
 * @param {Function} callback 回调函数
 */
export const validatePhone = (rule, value, callback) => {
    // 手机号正则：支持13、14、15、16、17、18、19开头的11位数字
    const phoneReg = /^1[3-9]\d{9}$/

    if (!value) {
        return callback(new Error('请输入手机号'))
    }

    if (!phoneReg.test(value)) {
        return callback(new Error('请输入正确的手机号格式'))
    }

    callback()
}

/**
 * 验证邮箱
 * @param {*} rule 验证规则
 * @param {string} value 邮箱地址
 * @param {Function} callback 回调函数
 */
export const validateEmail = (rule, value, callback) => {
    // 邮箱正则
    const emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/

    if (!value) {
        return callback(new Error('请输入邮箱'))
    }

    if (!emailReg.test(value)) {
        return callback(new Error('请输入正确的邮箱格式'))
    }

    callback()
}

/**
 * 验证身份证号（18位）
 * @param {*} rule 验证规则
 * @param {string} value 身份证号
 * @param {Function} callback 回调函数
 */
export const validateIdCard = (rule, value, callback) => {
    // 身份证正则（简单验证）
    const idCardReg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/

    if (!value) {
        return callback(new Error('请输入身份证号'))
    }

    if (!idCardReg.test(value)) {
        return callback(new Error('请输入正确的18位身份证号'))
    }

    callback()
}

/**
 * 验证密码
 * 要求：8-20位，包含数字和字母
 * @param {*} rule 验证规则
 * @param {string} value 密码
 * @param {Function} callback 回调函数
 */
export const validatePassword = (rule, value, callback) => {
    // 密码正则：8-20位，包含数字和字母
    const passwordReg = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,20})$/

    if (!value) {
        return callback(new Error('请输入密码'))
    }

    if (!passwordReg.test(value)) {
        return callback(new Error('密码长度为8-20位，且必须包含数字和字母'))
    }

    callback()
}

/**
 * 验证URL地址
 * @param {*} rule 验证规则
 * @param {string} value URL地址
 * @param {Function} callback 回调函数
 */
// export const validateUrl = (rule, value, callback) => {
//     // URL正则（简单验证）
//     const urlReg = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w.-]*)*\/?$/
//
//     if (!value) {
//         return callback(new Error('请输入URL地址'))
//     }
//
//     if (!urlReg.test(value)) {
//         return callback(new Error('请输入正确的URL格式'))
//     }
//
//     callback()
// }

/**
 * 验证正整数
 * @param {*} rule 验证规则
 * @param {string|number} value 数值
 * @param {Function} callback 回调函数
 */
export const validatePositiveInteger = (rule, value, callback) => {
    const integerReg = /^[1-9]\d*$/

    if (value === undefined || value === null || value === '') {
        return callback(new Error('请输入数字'))
    }

    if (!integerReg.test(value)) {
        return callback(new Error('请输入正整数'))
    }

    callback()
}

/**
 * 验证金额（最多两位小数）
 * @param {*} rule 验证规则
 * @param {string|number} value 金额
 * @param {Function} callback 回调函数
 */
export const validateAmount = (rule, value, callback) => {
    // 金额正则：正数，最多两位小数
    const amountReg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^0\.\d{1,2}$)/

    if (value === undefined || value === null || value === '') {
        return callback(new Error('请输入金额'))
    }

    if (!amountReg.test(value)) {
        return callback(new Error('请输入正确的金额格式（最多两位小数）'))
    }

    callback()
}

/**
 * 验证中文名称
 * @param {*} rule 验证规则
 * @param {string} value 中文名称
 * @param {Function} callback 回调函数
 */
export const validateChineseName = (rule, value, callback) => {
    // 中文正则：仅包含汉字
    const chineseReg = /^[\u4e00-\u9fa5]+$/

    if (!value) {
        return callback(new Error('请输入名称'))
    }

    if (!chineseReg.test(value)) {
        return callback(new Error('名称只能包含中文'))
    }

    callback()
}

export default {
    validatePhone,
    validateEmail,
    validateIdCard,
    validatePassword,
    // validateUrl,
    validatePositiveInteger,
    validateAmount,
    validateChineseName
}
